// @Conf
// #hasDoc=true

// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-10-16T15:04:57Z                      #

// ##############################################################

/**
 * Výsledek změny hesla.
 */

/**
 * Změna proběhla.
 */
export const OK = 'OK';

/**
 * Vyčerpaný počet pokusů o přihlášení, klient by měl provést redirect na portál (a tam by mělo proběhnout odhlášení) - jako při smazání účtu.
 */
export const REDIRECT_PORTAL = 'REDIRECT_PORTAL';

/**
 * Seznam všech hodnot.
 */
export const values = [
    OK,
    REDIRECT_PORTAL
];

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [OK]: {caption: 'Změna proběhla.'},
    [REDIRECT_PORTAL]: {caption: 'Vyčerpaný počet pokusů o přihlášení, klient by měl provést redirect na portál (a tam by mělo proběhnout odhlášení) - jako při smazání účtu.'}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}